import OstroDynamicContent from 'app/components/OstroDynamicContent';
import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';

import { BubbleMessagesProps } from './types';

const MESSAGE_CHANGE_INTERVAL = 4000;

const animationVariants = {
  initial: { opacity: 0, y: 34 },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.2,
      ease: [0.34, 1.56, 0.64, 1],
    },
  },
  exit: {
    y: -34,
    opacity: 0,
    transition: { duration: 0.1, ease: 'easeIn' },
  },
};

const BubbleMessages = ({ id, messages }: BubbleMessagesProps) => {
  const [index, setIndex] = useState<number>(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIndex((prevIndex) => {
        const newIndex = (prevIndex + 1) % messages.length;
        if (newIndex === 0) {
          clearInterval(intervalId);
        }
        return newIndex;
      });
    }, MESSAGE_CHANGE_INTERVAL);

    return () => clearInterval(intervalId);
  }, [messages]);

  return (
    <motion.div
      id={id}
      initial={{ opacity: 0, width: 0 }}
      animate={{ opacity: 1, width: 270 }}
      exit={{ opacity: 0, width: 0 }}
      transition={{ duration: 1, ease: [0.25, 0.1, 0.25, 1] }}
      className="bg-brand-openBubbleBackground overflow-hidden flex items-center justify-center"
    >
      <AnimatePresence mode="wait">
        <motion.div
          key={index}
          variants={messages.length > 1 ? animationVariants : undefined}
          initial="initial"
          animate="animate"
          exit="exit"
          className="px-4 line-clamp-2"
        >
          <div className="min-w-[230px]">
            <OstroDynamicContent
              id="ostro-suggested-article-title"
              content={messages[index].text}
              className="[&_p]:(mb-0 inline) min-w-fit"
            />
          </div>
        </motion.div>
      </AnimatePresence>
    </motion.div>
  );
};

export default BubbleMessages;
